import React from 'react'

import './DefaultLayoutTemplate.css'

import { userManager } from '@/Core/Managers'
import type { UIManager } from '@/Core/Managers/UI'

import { DefaultLayout } from './Components/DefaultLayout/DefaultLayout'
import { DefaultLoadTemplate } from './Components/DefaultLoadTemplate'
import { restClient } from '@/Core'

import { CentrifugoConnector } from './Components/CentrifugoConnector'
import { AppConfig } from '@/Ship/Configs/AppConfig'
import { OfficeViewerHost } from '@/Ship/Components/OfficeViewer'
import { counterManager } from '@/Ship/Stores/CounterManager'
import { LoginPageTemplate } from './Components/LoginPageTemplate'

import ChatButton from '@/Containers/CommunicationSection/ChatContainer/Components/ChatButton'
import ChatDrawer from '@/Containers/CommunicationSection/ChatContainer/Components/ChatDrawer'
import { DiskFileViewerHost, DiskUploadHost } from '@/Containers/DiskSection/DiskContainer/Hooks'

interface DefaultLayoutTemplateProps {
    layoutContext?: UIManager
    children: React.ReactNode
}

// Функція перевірки доступу
export const accessFn = () => userManager.isAuthorized

// Компонент для відображення помилки 403
export const templateError403 = () => <LoginPageTemplate />

// Асинхронна функція завантаження даних перед рендером layout
// Виконується один раз при монтуванні Layout
// Завантажує дані користувача включаючи permissions для перевірки доступів до ресурсів
export const loadData = async () => {
    const startTime = Date.now()
    const minDuration = 1000

    if (userManager.isAuthorized) {
        try {
            // Завантажуємо дані користувача з бекенду
            // Відповідь повинна містити поле permissions з правами доступу
            const user = (await restClient.get(AppConfig.restUserMe)) as unknown as { id?: number } | null

            if (!user?.id) {
                userManager.logout(true)
            } else {
                // Бейджі меню (ADR 030) — паралельно з мінімальною паузою
                // завантаження, не чекаючи; далі їх рухають події Centrifugo
                void counterManager.load()
            }

            const elapsed = Date.now() - startTime
            const remaining = minDuration - elapsed

            if (remaining > 0) {
                await new Promise((resolve) => setTimeout(resolve, remaining))
            }
        } catch (error) {
            console.error('[loadData] Error loading user data:', { error })
            userManager.logout(true)
        }
    }

    const elapsed = Date.now() - startTime
    const remaining = minDuration - elapsed

    if (remaining > 0) {
        await new Promise((resolve) => setTimeout(resolve, remaining))
    }

    return null
}

// Компонент, який відображається під час виконання loadData
export const loadTemplate = DefaultLoadTemplate

export const DefaultLayoutTemplate = ({ children }: DefaultLayoutTemplateProps) => {
    return (
        <>
            <CentrifugoConnector />
            <DefaultLayout>{children}</DefaultLayout>
            {/* Чат: плаваюча кнопка з лічильником непрочитаних + дровер */}
            <ChatButton />
            <ChatDrawer />
            {/* Редактор документів (Collabora): одна шухляда на застосунок, SPEC-012 §7.10 */}
            <OfficeViewerHost />
            {/* Менеджер завантажень диска: переживає переходи між модулями (DISK-001 §6) */}
            <DiskUploadHost />
            {/* Переглядач файлів диска: поверх будь-якого модуля (`openDiskFile`, `?file=` на диску) */}
            <DiskFileViewerHost />
        </>
    )
}
